module.exports = __webpack_public_path__ + "img/cn_pocket-7.dd44aed.jpg";